import { useContext } from 'react';

import NavigationContext from './navigation.context';

function useNavigation() {
  const context = useContext(NavigationContext);

  if (!context) {
    throw new Error('useNavigation must be used within NavigationContext');
  }

  return context;
}

export default useNavigation;